function libReflectInput(elm) {
    const input = elm.querySelector('[data-target~="input"]');
    const reflect = elm.querySelector('[data-target~="reflect"]');

    if(!input || !reflect) return;

    input.addEventListener('input',function () {
        if(input.reportValidity()) {
            reflect.innerHTML = input.value;
        }
    });
}
